import 'flickity/dist/flickity.pkgd'
import vidim from 'vidim/dist/vidim'

window.vidim = vidim

const splashSlider = jQuery('.splash__holder'),
    splashSlides = jQuery('.splash__holder .splash')

let splashVideoPrev

if (splashSlider.length > 0 && splashSlides.length > 1) {

    splashSlider.flickity({
        cellSelector: '.splash',
        prevNextButtons: true,
        wrapAround: true,
        pageDots: true,
        cellAlign: 'left',
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
        },
        //setGallerySize: false,
    })

    setTimeout(function () {
        splashSlider.flickity('select', 0)
    }, 3000)

    let splashSliderData = splashSlider.data('flickity')

    splashSlider.on('select.flickity', function () {
        if (splashVideoPrev !== undefined) {
            splashVideoPrev.pause()
        }

        if (jQuery(splashSliderData.selectedElement).hasClass('splash--video')) {

            splashVideoPrev = window[`splash${splashSliderData.selectedIndex}`]
            window[`splash${splashSliderData.selectedIndex}`].play()

        }
    })
}


const partnersSlider = jQuery('.logo-bar'),
    partnersSlides = jQuery('.logo-bar .partner-logo')

if (partnersSlider.length > 0 && partnersSlides.length > 1) {

    partnersSlider.flickity({
        cellSelector : '.partner-logo',
        wrapAround   : true,
        cellAlign    : 'left',
        pageDots     : false,
        groupCells   : true,
        autoPlay     : true,
        draggable    : false,
        arrowShape   : {
            x0: 30,
            x1: 55, y1: 30,
            x2: 65, y2: 30,
            x3: 40
        },
    })

}
